import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl: string = 'https://mevoz.net/soab'; // Adjust the base URL as needed

  constructor(private http: HttpClient) { }

  getAllUsers(): Observable<any> {
    return this.http.get(`${this.baseUrl}/allUsers`);
  }

  getAllOrganizations(): Observable<any> {
    return this.http.get(`${this.baseUrl}/organizations`);
  }

  getJobsByOrganization(organizationId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/jobs/organization/${organizationId}`);
  }

  getAllJobs(): Observable<any> {
    return this.http.get(`${this.baseUrl}/jobs`);
  }

  // Method to fetch job details by job ID
  getJobDetailsById(jobId: string | number): Observable<any> {
    return this.http.get(`${this.baseUrl}/jobs/${jobId}`);
  }


    // New method to fetch 8 random featured jobs
    getFeaturedJobs(): Observable<any> {
      return this.http.get(`${this.baseUrl}/featuredJobs`);
    }

    getUserInfo(): Observable<any> {
      const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${token}`
        })
      };
      return this.http.get(`${this.baseUrl}/userInfo`, httpOptions);
    }

    // Method to edit user profile
  editUserProfile(userData: any): Observable<any> {
    const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };

    // Assuming the endpoint to edit user profile is '/editUserProfile'
    return this.http.put(`${this.baseUrl}/editUserProfile`, userData, httpOptions);
  }

  applyForJob(jobId: number, organizationId: number): Observable<any> {
    const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };

    // Prepare the body of the POST request
    const body = { jobId, organizationId };

    return this.http.post(`${this.baseUrl}/applyForJob`, body, httpOptions);
  }


  // Method to check if the current user has applied for a specific job
checkUserApplication(jobId: number): Observable<{hasApplied: boolean}> {
  const token = localStorage.getItem('token');
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };

  return this.http.get<{hasApplied: boolean}>(`${this.baseUrl}/checkApplication/${jobId}`, httpOptions);
}

getOrganizationsWithJobs(): Observable<any> {
  return this.http.get(`${this.baseUrl}/organizationsWithJobs`);
}

uploadCV(file: File, userId: number): Observable<any> {
  const formData: FormData = new FormData();
  formData.append('file', file);
  formData.append('userId', userId.toString());

  const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };

  return this.http.post(`${this.baseUrl}/upload-cv`, formData, httpOptions);
}



checkUserCv(): Observable<any> {
  const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };

  return this.http.get(`${this.baseUrl}/check-cv`, httpOptions);
}

getAppliedJobs(): Observable<any> {
  const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };

  return this.http.get(`${this.baseUrl}/applied-jobs`, httpOptions);
}


deleteApplication(jobId: string): Observable<any> {
  const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };

  return this.http.delete(`${this.baseUrl}/deleteApplication/${jobId}`, httpOptions);
}

validateToken(): Observable<any> {
  const token = localStorage.getItem('token');
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };
  return this.http.get(`${this.baseUrl}/validate-token`, httpOptions);
}


getAvailableTimeSlots(jobId: number): Observable<any> {
  const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };
  return this.http.get(`${this.baseUrl}/available-time-slots/${jobId}`, httpOptions);
}


// Adjusted Angular service method to match the updated backend
bookTimeSlot(timeSlotId: number, date: string, start_time: string, end_time: string, jobId: number): Observable<any> {
  const token = localStorage.getItem('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  // Adjust the body to omit boothId and include date
  const body = { timeSlotId, date, start_time, end_time, jobId };
  return this.http.post(`${this.baseUrl}/book-time-slot`, body, { headers });
}



}


